import { MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons";
import { HStack, Icon, Text, useTheme } from "native-base";
import React, { useMemo } from "react";

import { OrderStatusEnum } from "@/interfaces/domain/Order";

type OrderStatusBadgeProps = {
  orderStatus: OrderStatusEnum;
};

const OrderStatusBadge = ({ orderStatus }: OrderStatusBadgeProps) => {
  const { colors } = useTheme();
  const infoStatus = useMemo(() => {
    switch (orderStatus) {
      case OrderStatusEnum.SCHEDULED:
        return {
          description: "Pedido agendado",
          icon: <MaterialCommunityIcons name="clock-outline" />,
          color: colors.primary[600],
        };
      case OrderStatusEnum.CANCELED:
        return {
          description: "Pedido cancelado",
          icon: <MaterialCommunityIcons name="close-circle-outline" />,
          color: colors.error[400],
        };
      case OrderStatusEnum.IN_DELIVERY:
      case OrderStatusEnum.ARRIVED:
        return {
          description: "Saiu para entrega",
          icon: <MaterialIcons name="delivery-dining" />,
          color: colors.primary[600],
        };
      case OrderStatusEnum.DELIVERED:
      case OrderStatusEnum.FINISHED:
        return {
          description: "Pedido finalizado",
          icon: <MaterialCommunityIcons name="check" />,
          color: colors.success[600],
        };
      default:
        return {
          description: "Pedido em andamento",
          icon: <MaterialCommunityIcons name="package-variant-closed" />,
          color: colors.primary[600],
        };
    }
  }, [orderStatus]);
  return (
    <HStack space="2" alignItems="center">
      <Icon as={infoStatus.icon} size="lg" color={infoStatus.color} />
      <Text fontSize="lg" color={infoStatus.color}>
        {infoStatus.description}
      </Text>
    </HStack>
  );
};

export default OrderStatusBadge;
